import React from 'react';
import { Sparkles, Download } from 'lucide-react';
export function TopBar() {
  return <div className="w-full bg-sage-900 text-sand-50 text-xs md:text-sm font-medium border-b border-gold-500/20" data-id="element-311">
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-3 md:gap-6 flex-wrap text-center" data-id="element-312">
        <div className="flex items-center gap-2" data-id="element-313">
          <Sparkles className="w-4 h-4 text-gold-400 flex-shrink-0" data-id="element-314" />
          <span className="tracking-widest uppercase text-[10px] md:text-xs" data-id="element-315">
            Piezas decorativas en menos de 24 hs.
          </span>
        </div>
        <span className="hidden md:inline text-sage-500" data-id="element-316">|</span>
        <div className="flex items-center gap-2" data-id="element-317">
          <Download className="w-4 h-4 text-terracotta-400 flex-shrink-0" data-id="element-318" />
          <span className="tracking-widest uppercase text-[10px] md:text-xs" data-id="element-319">
            Acceso inmediato
          </span>
        </div>
      </div>
    </div>;
}